// TODO: DS depends on MUI Base, not MUI Material, so we should export this type from DS
import { TBaseItem } from "@centricsoftware/design-system";
import { AutocompleteChangeDetails, AutocompleteChangeReason } from "@mui/material";
import { useFormStore, useStatefulFormField } from "csi/middleware/form/index";
import { observer } from "mobx-react-lite";
import React, { useCallback } from "react";
import { useComponentOverlayContext } from "../hooks";
import SingleSelect, { SingleSelectProps } from "./SingleSelect";
import { OnLoadOptions } from "./store/SelectStoreBase";

export interface FormFieldSingleSelectProps extends SingleSelectProps { }

const FormFieldSingleSelect = observer(({
	aggregateStore,
	...otherProps
}: FormFieldSingleSelectProps) => {
	const formStore = useFormStore();
	const field = useStatefulFormField();
	const isParentOverlay = useComponentOverlayContext();
	const { attributeId, id, label, transientInfo: { disabled, required, value } } = field;
	const [fieldInvalid, fieldMessage] = formStore?.getFieldError(id) || [false, ""];
	let options = formStore?.getFieldOptions(attributeId, true);

	const onLoadOptions: OnLoadOptions = (items: TBaseItem[]): void => {
		options = items;
	};

	const onChange = useCallback((
		event: React.SyntheticEvent<Element, Event>,
		value: TBaseItem | NonNullable<TBaseItem>,
		reason?: AutocompleteChangeReason,
		details?: AutocompleteChangeDetails<TBaseItem>,
	): void => {
		if (reason === "clear") {
			value = null;
		}
		formStore?.handleFieldChange(null, field, value?.id);
	}, [value]);

	return (
		<SingleSelect
			aggregateStore={aggregateStore}
			dataCsiAutomation={id}
			disableClearable={required}
			disabled={disabled}
			error={fieldInvalid}
			errorMessage={fieldMessage}
			label={label}
			onChange={onChange}
			onLoadOptions={onLoadOptions}
			options={options}
			required={required}
			tabIndex={isParentOverlay ? -1 : undefined}
			value={formStore ? value as string : ""}
			{...otherProps}
		/>
	);
});

export default FormFieldSingleSelect;
